import Modal from '@components/modal/Modal';
import useModalHook from '@hooks/useModalHook';
import * as SC from '@components/channelList/modal/SettingModal.style';
import { useState } from 'react';
import strings from '@i18n/index';
import { SettingLanguage, SettingTheme, SettingsNoti } from '@assets/icons';
import Alarm from '@components/modal/settings/Alarm';
import Language from '@components/modal/settings/Language';
import Theme from '@components/modal/settings/Theme';
import CloseBtn from '@components/common/buttons/CloseBtn';
import Icon from '@components/common/Icon';
import useThemeStore from '@stores/themeStore';

export type SettingModalProps = { [x: string]: any };

export type Settings = 'alarm' | 'language' | 'theme';

export type TabItem = {
  index: number;
  value: Settings;
  label: string;
  icon: React.ReactNode;
};

// SettingLanguage,
//     SettingsNoti,
//     SettingTheme,

const SettingModal = () => {
  const { theme } = useThemeStore();
  const { closeModal } = useModalHook();

  const [selectedTab, setSelectedTab] = useState<Settings>('alarm');

  const TabObjs: TabItem[] = [
    {
      index: 0,
      value: 'alarm',
      label: strings.NOTICE,
      icon: <SettingLanguage />,
    },
    {
      index: 1,
      value: 'language',
      label: strings.SETTINGS__CHANGE_LANGUAGE,
      icon: <SettingsNoti />,
    },
    {
      index: 2,
      value: 'theme',
      label: strings.SETTINGS__THEME,
      icon: <SettingTheme />,
    },
  ];

  const getIndex = (): number => {
    switch (selectedTab) {
      case 'alarm':
        return 0;
      case 'language':
        return 1;
      case 'theme':
        return 2;
      default:
        return 0;
    }
  };

  const index = getIndex();

  return (
    <Modal
      title={strings.ELECTRON.MENU_SETTINGS}
      width="720px"
      // height="540px"
      hasBorderBottom
      hideFooter={true}
      subChildren={
        <CloseBtn>
          <Icon size="22px" icon="IcClose" color={theme === 'dark' ? '#fff' : '#333'} />
        </CloseBtn>
      }
      onSubAction={() => closeModal('settingModal')}
      onCancel={() => closeModal('settingModal')}
    >
      <SC.Box>
        <SC.Left index={index}>
          <SC.Tabs mode={theme}>
            {TabObjs.map((tab) => (
              <SC.Tab
                mode={theme}
                isSelected={tab.value === selectedTab}
                key={tab.value}
                onClick={() => {
                  setSelectedTab(tab.value);
                }}
              >
                <SC.TabBtn>
                  {tab.icon}
                  <SC.TabBtnLabel>{tab.label}</SC.TabBtnLabel>
                </SC.TabBtn>
              </SC.Tab>
            ))}
          </SC.Tabs>
        </SC.Left>
        <SC.Right>
          {selectedTab === 'alarm' && <Alarm />}
          {selectedTab === 'language' && <Language />}
          {selectedTab === 'theme' && <Theme />}
        </SC.Right>
      </SC.Box>
    </Modal>
  );
};

export default SettingModal;
